/* ZISTY HOME — configurateur « Composer ma table » */
if (!customElements.get('zisty-bundle')) {
  class ZistyBundle extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.fmt = new Intl.NumberFormat(d.locale || 'fr-BE', { style: 'currency', currency: d.currency || 'EUR' });
      this.rules = [
        { min: parseInt(d.min2, 10) || 8, rate: (parseFloat(d.rate2) || 0) / 100 },
        { min: parseInt(d.min1, 10) || 4, rate: (parseFloat(d.rate1) || 0) / 100 },
      ].sort((a, b) => b.min - a.min);
      this.freeShipping = parseInt(d.freeShipping, 10) || 0;
      this.addEventListener('change', () => this.update());
      this.querySelector('[data-add]').addEventListener('click', () => this.addToCart());
      if (!this.querySelector('input[name^="tier-"]:checked')) {
        const first = this.querySelector('input[name^="tier-"]');
        if (first) first.checked = true;
      }
      this.update();
    }

    state() {
      const coll = this.querySelector('input[name^="collection-"]:checked');
      const guestsInput = this.querySelector('input[name^="guests-"]:checked');
      const tier = this.querySelector('input[name^="tier-"]:checked');
      const addons = [...this.querySelectorAll('.zs-addon input:checked')];
      return { collection: coll ? coll.value : '', guests: guestsInput ? parseInt(guestsInput.value, 10) : 1, tier, addons };
    }

    money(cents) {
      return this.fmt.format(cents / 100);
    }

    update() {
      const s = this.state();
      if (!s.tier) return;
      const lines = [];
      const tierPrice = parseInt(s.tier.dataset.price, 10) || 0;
      lines.push([`${s.tier.dataset.name} × ${s.guests}`, tierPrice * s.guests]);
      s.addons.forEach((a) => {
        const qty = a.dataset.mode === 'per_guest' ? s.guests : 1;
        lines.push([a.dataset.name + (qty > 1 ? ` × ${qty}` : ''), (parseInt(a.dataset.price, 10) || 0) * qty]);
      });
      const sub = lines.reduce((t, l) => t + l[1], 0);
      const rule = this.rules.find((r) => s.guests >= r.min && r.rate > 0);
      const disc = rule ? Math.round(sub * rule.rate) : 0;
      const total = sub - disc;

      this.querySelector('[data-summary-title]').textContent = `${s.tier.dataset.name} · ${s.guests}`;
      this.querySelector('[data-summary-coll]').textContent = s.collection ? `Collection ${s.collection}` : '';
      const box = this.querySelector('[data-summary-lines]');
      box.replaceChildren();
      const row = (label, value, cls) => {
        const div = document.createElement('div');
        if (cls) div.className = cls;
        const a = document.createElement('span');
        a.textContent = label;
        const b = document.createElement('span');
        b.textContent = value;
        div.append(a, b);
        box.append(div);
      };
      lines.forEach((l) => row(l[0], this.money(l[1])));
      if (rule) row(`Remise bundle −${Math.round(rule.rate * 100)} %`, `−${this.money(disc)}`, 'zs-summary__disc');
      else {
        const next = [...this.rules].reverse().find((r) => r.rate > 0);
        if (next) row(`Remise dès ${next.min} convives`, '—', 'zs-summary__disc');
      }
      if (this.freeShipping) row('Livraison', total >= this.freeShipping ? 'Offerte' : 'Calculée au panier');
      this.querySelector('[data-summary-total]').textContent = this.money(total);

      const ready = s.tier.dataset.variant && s.tier.dataset.available === 'true';
      const btn = this.querySelector('[data-add]');
      btn.disabled = !ready;
      this.setMsg(ready ? '' : 'Ce niveau n’est pas encore disponible en ligne.', !ready);
    }

    setMsg(text, isError) {
      const m = this.querySelector('[data-msg]');
      m.hidden = !text;
      m.textContent = text;
      m.classList.toggle('zs-summary__msg--error', !!isError);
    }

    async addToCart() {
      const s = this.state();
      if (!s.tier || !s.tier.dataset.variant) return;
      const bundleId = `table-${Date.now().toString(36)}`;
      const props = { Convives: String(s.guests), _bundle: bundleId };
      if (s.collection) props.Collection = s.collection;
      const items = [{ id: Number(s.tier.dataset.variant), quantity: s.guests, properties: props }];
      s.addons.forEach((a) => {
        if (!a.dataset.variant || a.dataset.available !== 'true') return;
        items.push({ id: Number(a.dataset.variant), quantity: a.dataset.mode === 'per_guest' ? s.guests : 1, properties: { _bundle: bundleId } });
      });
      const btn = this.querySelector('[data-add]');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${this.dataset.cartAddUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible');
        this.setMsg('Table ajoutée au panier.', false);
        window.location.href = this.dataset.cartUrl;
      } catch (e) {
        this.setMsg(`La table n'a pas pu être ajoutée : ${e.message}. Réessayez ou contactez-nous.`, true);
        btn.disabled = false;
      } finally {
        btn.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('zisty-bundle', ZistyBundle);
}
